import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom"
import { AppRoutes, getAppRouteByPathname } from "../app/app-routes";
import { AppMenuEvents } from "../events/app-menu";
import { EventNotificationService } from "../framework/services/event-notification";
import { getUtcNowUnixTimestamp } from "../framework/utils/date-time";
import { BwjViewState } from "../framework/components/bwj-view-manager";
import { PresenterAccountService } from "./account";

export const usePageManager = () => {
    const location = useLocation();
    const [lastApprovedLocation, setLastApprovedLocation] = useState<string | undefined>(undefined);
    const history = useHistory();
    const [viewState, setViewState] = useState(BwjViewState.Ready);

    useEffect(() => {
        const currentRoute = getAppRouteByPathname(location.pathname);

        // if the current route is known and does not allow invalid subscription,
        // we must check the signed in account subscription validity
        if(!!currentRoute && currentRoute.allowInvalidSubscription === false) {
            setViewState(BwjViewState.Loading);

            PresenterAccountService.myAccount()
            .then(account => {
                setViewState(BwjViewState.Ready);

                const now = getUtcNowUnixTimestamp();
                // current subscription is valid - route is approved
                if(now < account.accountExpirationDate) {
                    setLastApprovedLocation(location.pathname);
                } else {
                    history.push(AppRoutes.home.url());
                }
            })
            .catch(() => setViewState(BwjViewState.Error));
        } else { // routes that don't care whether the subscription is valid, and 404 routes are always approved
            setLastApprovedLocation(location.pathname);
        }

        if(currentRoute?.sideMenuSupported === true) {
            EventNotificationService.dispatch(AppMenuEvents.MenuAvailable);
        } else {
            EventNotificationService.dispatch(AppMenuEvents.MenuUnavailable);
        }
    }, [location, history]);

    const vs = viewState === BwjViewState.Ready && location.pathname !== lastApprovedLocation ?
        BwjViewState.Custom : viewState;
    return vs;
}